module.exports = {
  invoice_drawCollectInvoice: 'Draw/Collect Invoice',
  invoice_invoiceCategory: 'InvoiceCategory',
  invoice_queryInvoice: 'Query Invoice',
  invoice_invoiceDownloadLabel: 'Download',
  invoice_electronicInvoiceDownload: 'ElectronicInvoiceDownload',
  invoice_sendEmail: 'Send',
  invoice_mailSend: 'MailBoxSendTo',
  invoice_sendEmailLog: 'SendLog',
  invoice_downloadTimes: 'CustomerDownloadTimes',
  invoice_electronicInvoiceSendStatus: 'ElectronicInvoiceSendStatus',
  invoice_download: 'download',
  invoice_salesDepartment: '営業部門（販売担当）',
  invoice_opDepartment: 'Operation Department',
  invoice_chineseDescriptionOfGoods: 'Chinese Description Of Goods',
  invoice_englishDescriptionOfGoods: 'English Description Of Goods',
  billingJob_taxRate: '税率',
  invoice_hedging: 'Hedging',
  invoice_selectTheHedging: 'Please check and select the hedging',
  invoice_return: 'Return',
  invoice_query: 'Query',
  invoice_invoicing: 'Invoicing',
  invoice_collectInvoice: 'Collect Invoice',
  billingJob_billDate: '伝票日付',
  invoice_confirm: 'Confirm',
  invoice_hedgingInvoice: 'Hedging Invoice',
  invoice_hedgingCollectingInvoice: 'Hedging Collecting Invoice',
  invoice_cancelBillConfirmation: 'Cancel Bill Confirmation',
  invoice_revenueAndExpenditureMethod: '収支方式',
  invoice_all: 'All',
  invoice_convert: 'Convert',
  invoice_convert_after_tax: 'Convert After Tax',
  invoice_receivables: 'Receivables',
  invoice_payables: 'Payables',
  invoice_feeType: 'Fee Type:',
  invoice_domestic: 'Domestic',
  invoice_international: 'International',
  invoice_invoicingMethod: 'InvoiceMode',
  invoice_charges: 'Charges',
  invoice_business: 'Business',
  invoice_bill: 'Bill',
  invoice_accountStatement: 'Account Statement',
  invoice_defaultInformation: 'InvoicingByDefaultInformation',
  invoice_customer: 'Customer',
  invoice_businessNumber: '業務番号',
  invoice_consignationCompany: 'Consignation Company',
  invoice_settlementCompany: 'Settlement Company',
  invoice_mblNo: 'MBL No',
  invoice_vessel: 'Vessel',
  invoice_voyage: 'Voyage',
  invoice_billNo: 'Billing number',
  invoice_accountStatementNo: 'Account Statement No',
  invoice_paymentApplicationNo: 'Payment Application No',
  invoice_invoiceNo: 'インボイス番号',
  invoice_itemNo: 'プロジェクト番号',
  invoice_bookingNo: ' ブッキング番号',
  invoice_businessType: '業務種別',
  invoice_solicitationType: 'Solicitation Type',
  invoice_amountRange: '金額帯',
  invoice_chargeItem: 'チャージ項目',
  invoice_customerTypeId: 'Customer Type',
  invoice_businessDate: '業務日付',
  invoice_receivablesInvoicingDate: 'ReceivablesInvoicingDate',
  invoice_currency: ' 通貨',
  invoice_operation: ' 操作内容',
  invoice_sales: ' 売上',
  invoice_cargoSalesId: 'Cargo Sales',
  invoice_advanceMoneyForAnotherOrNot: 'Advance Money For Another Or Not',
  invoice_adjustedOrNot: '調整済みかどうか',
  invoice_wroteOffOrNot: 'Wrote Off Or Not',
  invoice_generatedBillsOrNot: '請求書作成済みかどうか',
  invoice_invoicedOrNot: 'インボイス発行済みかどうか',
  invoice_appliedForPaymentOrNot: '支払申請済みかどうか',
  invoice_receivablesInvoicingStatus: '売掛請求書ステータス',
  invoice_payablesInvoicingStatus: '買掛金請求ステータス ',
  invoice_department: 'Department',
  invoice_customerLevel: '顧客ランク',
  invoice_settlementMethod: '決済方法',
  invoice_contactPerson: 'Contact Person',
  invoice_businessReferenceNumber: '業務参照番号',
  invoice_invoiceHeader: '請求書ヘッダー名',
  invoice_inputBy: '入力者',
  invoice_dateCreated: 'Create Time',
  invoice_accrued: '未払計上',
  // invoice_invoicingMethod: '請求方式',
  invoice_businessStatus: '業務ステータス',
  invoice_feeStatus: '費用ステータス',
  invoice_confirmStatus: '確認ステータス',
  invoice_vesselAndVoyage: 'Vessel/Voyage',
  invoice_portOfLoading: 'Port Of Loading',
  invoice_portOfDestination: 'Port Of Destination',
  invoice_financialDate: '会計処理日',
  invoice_domesticOrInternational: 'Domestic Or Overseas',
  invoice_paymentType: 'Payment Type',
  invoice_quantity: '数量',
  invoice_taxIncludedPrice: '税込金額',
  invoice_taxExcludedPrice: '税抜金額',
  invoice_taxAmount: '消費税額',
  invoice_theAmountOfWriteOffs: 'Clearance Amount',
  invoice_amountNotWrittenOff: '未収残高',
  invoice_chargesRemarks: 'Charges Remarks',
  invoice_totalAmountNotWrittenOff: 'Total Amount Not Written Off',
  invoice_receivablesInvoicing: 'Receivables Invoicing',
  invoice_payablesInvoicing: 'Payables Invoicing',
  invoice_payablesCollectInvoice: 'Payables CollectInvoice',
  invoice_invoicingType: 'Invoicing Type',
  invoice_consolidatedInvoice: 'CombinedInvoicing',
  invoice_consolidatedInvoiceCollect: 'CombinedCollectInvoice',
  invoice_invoicingAccordingToBusiness: 'Invoicing according to business(according to Settlement Company)',
  invoice_invoicingAccordingToBusinessCollect: 'Collect Invoice according to business(according to Settlement Company)',
  invoice_invoicingAccordingToRecords: 'Invoicing according to records(Invoicing per record)',
  invoice_invoicingAccordingToRecordsCollect: 'Collect Invoice according to records(Invoicing per record)',
  invoice_invoicingPerRecord: 'Invoicing per record',
  invoice_invoiceType: 'Invoice type',
  invoice_CollectInvoiceType: 'Collect invoice type',
  invoice_makeType: 'Make type',
  invoice_invoiceStatus: 'Invoice Status',
  invoice_makePaper: 'PaperInvoice',
  invoice_makeElectronic: 'ElectronicInvoice',
  invoice_invoicingAccordingToCurrency: 'Invoicing according to currency',
  invoice_invoicingAccordingToCurrencyCollect: 'Collect invoice according to currency',
  invoice_invoicingPerCurrency: 'Invoicing per currency',
  invoice_invoicingPerCurrencyCollect: 'Collect invoice per currency',
  invoice_specifyInvoiceCurrency: 'Specify invoice currency',
  invoice_consolidatedCurrency: 'CombinedCurrency',
  invoice_invoicingCurrency: 'Invoicing currency',
  invoice_invoiceExchangeRate: 'Invoice exchange rate',
  invoice_invoicingCurrencyCollect: 'Collect invoice currency',
  invoice_showChargeDetails: 'InvoicePresentExpenseDetails',
  invoice_invoicingAccordingToFinancialExchangeRate: 'Invoicing according to Financial exchange rate',
  invoice_invoicingAccordingToFinancialExchangeRateCollect: 'Collect invoice according to Financial exchange rate',
  invoice_invoicingAccordingByBillingExchangeRate: 'Invoicing according by Billing exchange rate',
  invoice_invoicingAccordingByBillingExchangeRateCollect: 'Collect invoice according by Billing exchange rate',
  invoice_generateCostInvoice: 'Generate cost invoice',
  invoice_subTotal: 'Sub Total',
  invoice_exchangeRate: '為替レート',
  invoice_alwaysInvoicing: ' Always invoicing by the exchange rate',
  invoice_SplitChargeOnlyChangeQuantity: '分割後も「単価」は変化せず、「数量」は更新される',
  invoice_total: '合計',
  invoice_revenueAndExpenditureType: 'Revenue and expenditure type',
  invoice_invoicingExchangeRate: 'Invoicing exchange rate',
  invoice_InvoicingAmount: 'Invoicing amount',
  invoice_billBusinessNo: 'Bill/JobNumber',
  invoice_billBusinessDate: 'Bill/JobDate',
  invoice_accountBillBusinessDate: 'AccountStatement/Bill/JobNo',
  invoice_paymentNotificationAndBusiness: 'PaymentOrder/JobNo',
  invoice_invoiceInformation: 'Invoice Information',
  invoice_invoiceContent: 'Invoice Content',
  invoice_chargeDetails: 'ExpenseDetails',
  invoice_unitPrice: '単価',
  // invoice_quantity: '数量',
  invoice_amount: 'Amount',
  // invoice_invoiceNo: 'インボイス番号',
  invoice_invoiceDate: '請求日',
  invoice_invoicingDate: '請求日',
  invoice_bargeETD: 'Barge ETD',
  invoice_billPaymentNo: 'PaymentOrderNumber',
  invoice_proofDate: 'FinancialVouchersDate',
  invoice_writeOffStatus: 'Write off status',
  invoice_redChargesStatus: 'Red charges status',
  invoice_printOrNot: 'Print or not',
  invoice_invalidOrNot: 'Invalid or not',
  invoice_exportOrNot: 'Export or not',
  invoice_invoiceApplicant: 'Invoice applicant',
  invoice_invoiceVoider: 'invoice Voider',
  invoice_invoiceVoidTime: 'invoice VoidTime',
  invoice_totalCurrency: 'Total currency',
  invoice_notWrittenOffTotalCurrency: 'Total amount of unwritten off currencies',
  invoice_alreadyExportOrNot: 'Already export or not',
  invoice_havingInvoiceingNoOrNot: 'HaveInvoiceNoOrNot',
  invoice_exportProofFinancialOrNot: 'ExportFinancialVouchersOrNot',
  invoice_totalAmount: 'Total amount',
  invoice_taxFreeAmount: 'Tax free amount',
  invoice_customJobType: 'CustomizedJobType',
  invoice_containerNo: 'EQ No',
  invoice_voyageLine: '航路',
  invoice_separateNumber: 'House B/L',
  invoice_sp1: 'InvoiceCopy',
  invoice_sp2: 'PayerCompany',
  invoice_sp3: 'InvoiceNo',
  invoice_sp4: 'Remove',
  invoice_sp5: 'InvoiceDate',
  invoice_sp6: 'OriginalCurrency',
  invoice_sp7: 'InvoiceCurrency',
  invoice_sp8: 'OurBank',
  invoice_sp9: 'OurBankAccount',
  invoice_sp10: 'PlaceOfReceipt',
  invoice_sp11: 'PortOfDischarge',
  invoice_sp12: 'PlaceOfDelivery',
  invoice_sp13: 'DepartureDate',
  invoice_sp14: 'ArrivalDate',
  invoice_sp15: '請求書要求',
  invoice_sp16: 'Vessel/VoyageNo',
  invoice_sp17: 'ExpandDetails',
  invoice_sp18: 'CombineDetails',
  invoice_sp19: 'CommodityGoods',
  invoice_sp20: 'OriginalAmount',
  invoice_sp21: 'EquivalentAmount',
  invoice_sp22: 'EquivalentAmount',
  invoice_sp23: '備考',
  invoice_sp24: 'FinancialStatement',
  invoice_sp25: 'TotalAmount',
  invoice_sp26: '合計',
  invoice_sp27: 'CompanySeal',
  invoice_sp28: 'StatementReview',
  invoice_sp29: 'TaxRegistrationNumber',
  invoice_theLastPage: 'The last page',
  invoice_theNextPage: 'The next page',
  invoice_sp30: ' SetUpThisContentAsAcquiescentInvoiceInfo',
  invoice_sp31: '  SplitExpenses',
  invoice_back: 'Back',
  invoice_selectInvoiceNo: 'Select Invoice No',
  invoice_next: ' Next',
  invoice_invoiceConfirmation: 'InvoicingConfirmation',
  invoice_collectInvoiceConfirmation: 'CollectInvoiceConfirmation',
  invoice_save: 'Save',
  invoice_print: 'Print',
  invoice_printAll: 'Print All',
  invoice_CATISExport: 'CATIS Export',
  invoice_CATISPrint: 'CATIS Print',
  invoice_CATISInvalid: 'CATIS Invalid',
  invoice_cancel: 'Cancel',
  invoice_close: 'Close',
  invoice_view: 'View',
  invoice_forceDelete: 'Force delete',
  invoice_delete: 'Delete',
  invoice_invalid: 'Invalid',
  invoice_exportVATInvoice: 'Export VAT invoice',
  invoice_importVATInvoice: 'Import VAT invoice',
  invoice_applyForPayment: 'RequestWithdrawal',
  invoice_sp32: 'BaiWang Export',
  invoice_billPaymentState: 'RequestWithdrawalStatus',
  invoice_downLoad: 'DownLoad',
  invoice_BatchDownloadElectronicInvoice: 'Batch Download Electronic Invoice',
  invoice_UpdateInvoice: 'Modify invoice',
  invoice_ModifyInvoiceInformation: 'Modify invoice information',
  invoice_recheck: 'Review',
  invoice_cancelRecheck: 'CancelReview',
  invoice_approvedStatue: 'ReviewStatus',
  invoice_approvedBy: 'Reviewer',
  invoice_dateApproved: 'ReviewDate',
  invoice_incomePayDate: 'PaymentPeriod',
  invoice_isExtended: 'OverdueOrNot',
  invoice_incomeCostDate: 'PaymentPeriod',
  invoice_incomeCostRange: 'OverdueRange',
  invoice_sellTitle: 'Sell Title',
  invoice_placeOfDelivery: 'PlaceOfDelivery',
  invoice_userDefinedField1: 'UserDefinedField1',
  invoice_userDefinedField2: 'UserDefinedField2',
  invoice_userDefinedField3: 'UserDefinedField3',
  invoice_userDefinedField4: 'UserDefinedField4',
  invoice_differenceAdjustment: 'Difference Adjustment',
  invoice_businessCreateDate: 'JobCreateDate',
  invoice_dateTo: 'To',
  invoice_lockCheckBoxDate: 'Query Data For Only Two Years',
  invoice_queryLotsOfData: 'Query For Data Beyond Two Years',
  invoice_invoiceDateNotEmpty: 'InvoiceDate Not Empty',
  invoice_unlockInvoiceDateQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  invoice_businessDateNotEmpty: 'BusinessDate Not Empty',
  invoice_unlockBusinessDateQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  invoice_actualReceiptDate: 'Actual Receipt Date',
  invoice_targetVoucherNo: 'Target Voucher No',
  invoice_voucherDate: 'Voucher Date2',
  invoice_redPunch: 'RedPunch',
  invoice_etd: 'ETD',
  invoice_eta: 'ETA',
  invoice_notesOnReceipt: 'Notes on receipt',
  invoice_invoiceRemarks: 'Invoice remarks',
  invoice_settleDepartmentPrefix: '決済部門',
  invoice_denomination: 'Denomination',
  lastInvoicingDate: 'Last Invoicing Date',
  invoice_ATD: 'ATD',
  invoice_OperationTime: '処理日',
  invoice_updateRemark: 'Update Remark',
  OurBankAccountNo: 'Our Bank Account Number',
  OurBankCurrency: 'Currency Of Our Bank',
  RedChargesOrNot: 'Write back or not',
  revenueAndExpenditureType: 'Revenue and expenditure type',
  InvoiceDateCreated: 'Invoice Creation Date',
  ElInvoiceSendStatus: 'Electronic Invoice Sending Status',
  ElInvoiceSendPlatformStatus: 'Electronic invoice sending platform status',
  ElInvoiceSendEmailStatus: 'Electronic invoice sending email status',
  InvoicingByBusinessDateExchangeRate: 'Invoicing By Business Date Exchange Rate',
  InvoicingByBusinessDateExchangeRateCollect: 'Collect invoice By Business Date Exchange Rate',
  InvoicingByBusinessDateExchangeRateTips: 'Please select expense Invoicing on the same business date！',
  existUnconfirmedStatus: 'The Selected Bill Contains Bills In Unconfirmed Status. Continue Invoicing?',
  AutoCheckInvoicing: 'Auto Check Invoicing',
  AutoCheckInvoicingToolTips: 'After use, the invoice amount close to or equal to the preset amount will be automatically checked. Note: this function will not automatically issue invoice. If you need to issue invoice, please operate it manually.',
  DefaultInvoicingAmount: 'Default Invoicing Amount:',
  AutoCheckInvoicingAmount: 'Auto Check Invoicing Amount',
  AutoCheckInvoicingDialogToolTips: 'Automatically check that the total amount will be close to or equal to the preset amount.',
  AutoSplitCharge: 'Auto Split Charge',
  AutoCalculateSplit: 'Auto Calculate Split',
  AutoCalculateSplitResult: 'Auto Split Results',
  IncludingTaxAmountLimit: 'Upper Limit Of Price Including Tax:',
  AutoCheckInvoicingSuccess: 'After the operation is completed, the equivalent amount of the fee has been checked as: {0} yuan, if you need to modify it, please check the adjustment manually.',
  UseAutoCheckInvoicing: 'Select fees based on the preset invoicing amount',
  AutoAmountCanNotZero: 'Default Invoicing amount must be greater than 0!',
  ArMoreApForAutoCheckInvoicing: 'After the operation is completed, automatically check that the expense payable amount is greater than the receivable amount. Direct invoicing is regarded as Bill receipt, and manual adjustment is recommended.',
  invoice_invoicingAccordingToSettlementAgent: 'Invoicing according to records(according to SettlementAgent)',
  invoice_invoicingAccordingToSettlementAgentCollect: 'Collect Invoice according to records(according to SettlementAgent)',
  invoice_invoicingAccordingToTitle: 'Invoicing according to title(Each invoice title generates one invoice)',
  invoice_invoicingAccordingToTitleCollect: 'Collect invoice according to title(Each invoice title generates one invoice)',
  RequestTaxControlPlatformStatus: 'Request tax control platform status',
  GetInvoiceNumber: 'Get invoice number',
  NotDoInvoice: 'Invoice has not been made in cloud tax. Please make invoice first.',
  GetInvoiceNoSuccess: 'Get invoice number successfully!',
  GetInvoiceNoFail: 'Getting invoice number, please check later!',
  NotDoInvoiceBwjsy: 'Invoice has not been made in jsy tax. Please make invoice first.',
  GetInvoiceNoSuccessBwjsy: 'Get invoice number successfully!',
  GetInvoiceNoFailPart: 'Some failed to obtain invoice numbers, please try later!',
  NotInvoice: 'Invoice has not been made. Please make invoice first.',
  PaperTicketPrinting: 'Paper ticket printing',
  NameOfSeller: 'Name of seller',
  CNYReceived: 'CNY received',
  CNYNotReceived: 'CNY not received',
  CNYPaid: 'CNY paid',
  CNYNotPaid: 'CNY not paid',
  SpecificConstraintTypes: 'Specific constraint types',
  PurchaserInformation: 'Purchaser Information',
  SellerInformation: 'Seller Information',
  TypeOfTransport: 'Type of transport',
  TransportVehicleBrand: 'Transport vehicle brand',
  Origin: 'Origin',
  Destination: 'Destination',
  NameOfGoodsTransported: 'Name of goods transported',
  ServiceOfGoodsTransported: 'Service of goods transported',
  FeiRedApplicationStatus: 'Full power red ink application status',
  RedFlushReason: 'Cause of red flush',
  RedApplyFail: 'The red letter application failed. Please check the reason for the failure.',
  RedApplying: 'The red letter application has been sent out. Please be patient and wait for the application to be successful before proceeding with the "Golden Tax Export" operation.',
  BatchCheckNotRedStatus: 'Only invoices with red offset status are supported for operation. Please check again to complete the operation.',
  BatchCheckNotRedApplyInvoice: 'Only invoices that have not been applied for in red are supported for operation. Please check again to complete the operation.',
  BatchCheckRedApplySuccessInvoice: 'Only invoices with successful red ink application are supported for operation. Please check again to complete the operation.',
  BatchCheckRedFlushInvoice: 'Only batch simultaneous operation of invoices with the same status is supported. Please check again to complete the operation.',
  BatchCheckRedFlushInvoiceType: 'Only batch simultaneous operation of all electric invoices is supported. Please check again to complete the operation.',
  BatchCheckRedFlushInvoiceTipOne: 'The selected',
  BatchCheckRedFlushInvoiceTipTwo: ' ticket will be redundated',
  IncorrectInvoicing: 'Incorrect invoicing',
  SalesReturn: 'Sales Return',
  ServiceTermination: 'Service Termination',
  SalesAllowance: 'Sales Allowance',
  AllElectricInvoicing: 'All electric invoicing',
  RealPersonAuth: 'Real person authentication has expired',
  PersonAuth: 'Person Auth',
  WeChatScanningAgain: 'Please open the tax app, log in to the personal business interface, scan your face to log in, enter your account (phone number), scan your face to log in, and once successful, scan your code to complete real person authentication.',
  Certified: 'Certified',
  QdWarningTip: 'The State Administration of Taxation is urgently adjusting the interface for issuing all electronic invoices. Programmers are currently struggling urgently. During the interface upgrade period, please go to the national tax website for invoicing operations. We apologize for any inconvenience caused during this period.',
  FailureDescription: 'Request tax control platform Description',
  SelectRightInvoice: 'Please select an invoice that meets the conditions!',
  ApplyRed: 'ApplyRed',
  CancelApplyRed: 'CancelApplyRed',
  InvoiceNoImport: 'Invoice no import',
  BatchCheckRedFlushInvoiceTip: 'The selected {0} ticket will be redundated and the system will automatically generate a redundated expense that is the same as the original expense!',
  RateChangedTip: 'The exchange rate corresponding to the invoice date has changed. Do you want to update the invoice exchange rate synchronously?',
  RateChangedSuccess: ',Invoice exchange rate updated successfully!',
  SelectReasonForRedOffsetInvoice: 'Please select the reason for the red offset invoice',
  OnlyMaster: 'Only the main ticket',
  invoice_chargeCurrencyRate1: 'Currency Rate1',
  invoice_chargeCurrencyRate2: 'Currency Rate2',
  GetInvoiceNumberVietnam: 'Get invoice number(vietnam)',
  GetInvoicePdfVietnam: 'Get invoice pdf(vietnam)',
  GetInvoiceStateVietnam: 'Get invoice status(vietnam)',
  PaymentMethodVietnam: 'Payment Method(vietnam)',
  InvoiceStateVietnam: 'Invoice Status(vietnam)',
  PleaseThanOneInvoiceMerge: '結合するために1枚以上の請求書を選択してください。',
  Verification: '検証',
  InvoiceDocument: '請求書ファイル',
  Missing: '欠落している',
  StartingPleaseWaitForEmail: '請求書の統合実行を開始します。結果のメールをお待ちください。',
  NoExistsInTheData: '選択されたデータには、請求書ファイルが存在しません！'
}
